import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import { MDBDataTable } from "mdbreact";
import "./styles.css";
import axios from "axios";
import Select from "react-select";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Util from "../../../Common/util";
import API from "../../../Common/api";

var url = window.location.hostname;
var port = window.location.port;

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.EditToggle = this.EditToggle.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.changeICLDQty = this.changeICLDQty.bind(this);
    this.changeLooseQty = this.changeLooseQty.bind(this);
    this.changeTesterQty = this.changeTesterQty.bind(this);
    this.processUpdateData = this.processUpdateData.bind(this);
    this.Assigntoggle = this.Assigntoggle.bind(this);
    this.AssignUser = this.AssignUser.bind(this);
    this.CancelAssignToggle = this.CancelAssignToggle.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    this.handleFile2 = this.handleFile2.bind(this);
    this.state = {
      showPassword: false,
      EditModal: false,
      schemas: [],
      icldQty: "0",
      looseQty: "1",
      testerQty: "4",
      Assignmodal: false,
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  changeICLDQty(evt) {
    this.setState({
      icldQty: evt.target.value,
    });

    console.log(this.state.icldQty);
  }

  changeLooseQty(evt) {
    this.setState({
      looseQty: evt.target.value,
    });

    console.log(this.state.looseQty);
  }

  handleChange(event) {
    this.setState({
      value: event.target.data,
      grnValues: event.target.value,
    });

    console.log(this.state.grnValues);
    console.log(event.target.value);

    localStorage.setItem("fileName", event.target.value);
  }

  exportToCSV = (csvData, FileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, FileName + fileExtension);
  };

  handleFile2() {
    console.log("sdfghjdfg");
    const payload = {
      file_name: localStorage.getItem("fileName"),
      location: this.state.selectedLocation,
    };

    API.post("/picking/pickConfirmedReport/v1/", { param: payload })

      .then((response) => {
        console.log(JSON.stringify(response.data));
        this.exportToCSV(response.data, localStorage.getItem("fileName"));

        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        /*     var new_data = {};
     
             for(var i=0;i < response.data.length;i++){
                  var tmp = response.data[i];
                  if(new_data[tmp.userName] == undefined){
                      new_data[tmp.userName] = [response.data[i]];
                  }else{
                       new_data[tmp.userName].push(response.data[i]);
                  }
             
             }
     
             console.log(new_data);
             localStorage.setItem('printData' , JSON.stringify(new_data));
             console.log(localStorage.getItem('printData'));
     
           
     
             this.setState({
               loadingprintbtn: false,
               modal: false,
               showAssignButton: false,
               showPrintButton: true,
             })*/
      })
      .catch(function (error) {});
  }

  changeTesterQty(evt) {
    this.setState({
      testerQty: evt.target.value,
    });

    console.log(this.state.testerQty);
  }

  processUpdateData() {
    console.log(this.state.icldQty);
    console.log(this.state.looseQty);
    console.log(this.state.testerQty);
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentDidMount() {
    const payload = {
      location: this.state.selectedLocation,
      picksheetType: 3,
    };

    API.post("/picking/fetchPicksheetList/v1/", { param: payload })

      .then((response) => {
        console.log(response);
        this.setState({
          schemas: response.data,
        });
      })
      .catch(function (error) {});

    /*this.fetchGRNData();*/
  }

  EditToggle() {
    this.setState({
      EditModal: true,
    });
  }

  togglePressCancel() {
    this.setState({
      EditModal: false,
    });
  }

  Assigntoggle() {
    this.setState({
      Assignmodal: true,
    });
  }

  CancelAssignToggle() {
    this.setState({
      Assignmodal: false,
    });
  }

  AssignUser() {
    this.Assigntoggle();
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { EditModal } = this.state;
    const { Assignmodal } = this.state;

    const data = {
      columns: [
        {
          label: "Storage type",
          field: "ptl_id",
          sort: "asc",
          width: 150,
        },

        {
          label: "LB SKU ID",
          field: "lb_sku_id",
          sort: "asc",
          width: 150,
        },

        {
          label: "Basepack Code",
          field: "base_code",
          sort: "asc",
          width: 200,
        },

        {
          label: "Pick Type",
          field: "picktype",
          sort: "asc",
          width: 100,
        },
        {
          label: "TO Pick Qty ICLD",
          field: "to_pick_qty_icld",
          sort: "asc",
          width: 150,
        },
        {
          label: "TO Pick Qty Loose",
          field: "to_pick_qty_loose",
          sort: "asc",
          width: 150,
        },
        {
          label: "TO Pick Qty Tester",
          field: "to_pick_qty_tester",
          sort: "asc",
          width: 150,
        },
        {
          label: "MRP",
          field: "mrp",
          sort: "asc",
          width: 150,
        },
        {
          label: "PKD",
          field: "pkd",
          sort: "asc",
          width: 150,
        },
        {
          label: "Bin ID",
          field: "bin_id",
          sort: "asc",
          width: 100,
        },

        {
          label: "CBU Code",
          field: "cbu_code",
          sort: "asc",
          width: 100,
        },

        {
          label: "Batch",
          field: "batch",
          sort: "asc",
          width: 100,
        },

        {
          label: "Action",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
      rows: [
        {
          ptl_id: "Ambient",
          lb_sku_id: "LB-HUL-0000020",
          base_code: "19670",
          picktype: "BreakPack",
          to_pick_qty_icld: "0",
          to_pick_qty_loose: "4",
          to_pick_qty_tester: "0",
          mrp: 150,
          pkd: 619,
          bin_id: "B-E-1-2-1",
          cbu_code: "RCCD400",
          batch: "10F9000601",
          action: (
            <span
              style={{ cursor: "pointer", fontWeight: "bold", color: "blue" }}
              onClick={this.EditToggle}
            >
              {" "}
              Edit{" "}
            </span>
          ),
        },
      ],
    };

    return (
      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-5"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{ display: "inline", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Tester Id
                </span>

                <div
                  className="form__form-group-field col-xl-4"
                  style={{ display: "contents" }}
                >
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange}
                  >
                    <option value="0">Select Tester No.</option>
                    {this.state.schemas &&
                      this.state.schemas.length > 0 &&
                      this.state.schemas.map((schema) => {
                        return (
                          <option value={schema.fileName}>
                            {" "}
                            {schema.fileName}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field">
                  <ButtonToolbar className="form__button-toolbar">
                    <Button
                      onClick={this.handleFile2}
                      color="primary"
                      className="btn-sm"
                      style={{
                        fontWeight: "normal",
                        textTransform: "capitalize",
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",
                        padding: "5px 25px",
                        fontSize: "14px",
                      }}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </ButtonToolbar>
                </div>
              </div>
            </form>
          </CardBody>

          <CardBody style={{ marginTop: 20, display: "none" }}>
            <div className="table_header">
              <h4 style={{ fontWeight: "bold" }} className="subhead red-text">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    className="btn-sm"
                    onClick={this.processData}
                    type="submit"
                  >
                    Confirm
                  </Button>
                </ButtonToolbar>
              </h4>
            </div>
            <MDBDataTable striped bordered hover data={data} />
          </CardBody>
        </Card>

        <Modal
          isOpen={EditModal}
          toggle={this.EditToggle}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Edit Entry
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: "100%" }}>
              <div style={{ width: "50%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> LB SKU ID: </span>{" "}
                  <span> LB-HUL-0000020 </span>{" "}
                </span>
              </div>

              <div style={{ width: "50%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Total Qty: </span>{" "}
                  <span> 5 </span>{" "}
                </span>
              </div>

              <div style={{ width: "50%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> PKD: </span>{" "}
                  <span> 619 </span>{" "}
                </span>
              </div>

              <div style={{ width: "50%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP: </span>{" "}
                  <span> 150 </span>{" "}
                </span>
              </div>
            </div>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 10, marginTop: 15 }}
            >
              <tbody>
                <tr>
                  <td>Pick Qty ICLD</td>
                  <td>
                    <input
                      type="text"
                      defaultValue={this.state.icldQty}
                      onChange={this.changeICLDQty}
                      style={{ padding: 4, borderRadius: 2 }}
                    />{" "}
                  </td>
                </tr>

                <tr>
                  <td>Pick Qty LOOSE</td>
                  <td>
                    <input
                      type="text"
                      defaultValue={this.state.looseQty}
                      onChange={this.changeLooseQty}
                      style={{ padding: 4, borderRadius: 2 }}
                    />{" "}
                  </td>
                </tr>

                <tr>
                  <td>Pick Qty Tester</td>
                  <td>
                    <input
                      type="text"
                      defaultValue={this.state.testerQty}
                      onChange={this.changeTesterQty}
                      style={{ padding: 4, borderRadius: 2 }}
                    />{" "}
                  </td>
                </tr>
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  backgroundColor: "#3ea3fc",
                }}
                className="modal_ok"
                onClick={this.processUpdateData}
              >
                Update
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={Assignmodal}
          toggle={this.Assigntoggle}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body">
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 70 }}
            >
              <thead>
                <tr>
                  <th>Zone</th>
                  <th>Items</th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Zone1</td>
                  <td>50 </td>
                  <td>
                    <div className="form__form-group-field">
                      <Field
                        name="multiSelect"
                        component={renderMultiSelectField}
                        options={[
                          { value: "one", label: "One" },
                          { value: "two", label: "Two" },
                        ]}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.CancelAssignToggle}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  backgroundColor: "#3ea3fc",
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                Print
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
